import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import './utils/i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import 'material-symbols';

const root = ReactDOM.createRoot(document.getElementById('root'));

// For dev testing
// window.console.devLog = (value, ...rest) => {
//   if (process.env.NODE_ENV === 'development') {
//     console.log(value, ...rest);
//   }
// }
if (process.env.NODE_ENV === 'production') {
  console.log = () => { }
  console.error = () => { }
  console.trace = () => { }
  console.debug = () => { }
  console.warn = () => { }
} else {
  window.console.devLog = (value, ...rest) => {
    console.log(value, ...rest);
  }
}

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();